import { FileIcon, DownloadIcon } from "../../../ui-icons/upload";

export const LinksList = (props: any) => {
  const { links } = props;
  return (
    <div className="flex flex-row">
      <div className="flex flex-col w-full">
        {links.map((link: any, index: any) => (
          <a
            href={link.get_url()}
            download={true}
            key={index}
            className="flex flex-row justify-between gap-3 px-4 py-2 rounded-lg cursor-pointer upload bg-sp-gray"
          >
            <div className="flex flex-col grow">
              <div className="flex flex-row gap-x-2.5">
                <div className="flex flex-col items-center justify-center">
                  <FileIcon />
                </div>
                <div className="flex flex-col">{link.get_lookupValue()}</div>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center download-icon">
              <DownloadIcon />
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default LinksList;
